import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { purposeOfLoanList } from "assets/properties/properties";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
}));

const PurposeOfLoan = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [purposeOfloan, setPurposeOfLoan] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [disaledFields, setDisabledFields] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    if (leadId) {
      fetchLoanSummary();
    }
  }, [leadId]);

  const fetchLoanSummary = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_LEAD_DETAILS_FIND_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.loanPurpose) {
      setDisabledFields(true);
      setPurposeOfLoan(result?.data?.loanPurpose);
    }
  };

  const saveUserGeneralDetails = async () => {
    if (disaledFields) {
      navigate("/journey/BankAnalyser");
    } else {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.USER_LEAD_DETAILS_UPDATE_API + leadId,
        method: "PUT",
        authToken: authToken,
        data: {
          loanPurpose: purposeOfloan,
        },
      });
      if (res?.data?.error_code) {
        toastUpdate("Error", res.data.user_description, true);
        setCallInProgress(false);
      } else {
        setCallInProgress(false);
        navigate("/journey/BankAnalyser");
      }
    }
  };
  const isFormValid = () => {
    return disaledFields || purposeOfloan !== "";
  };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Purpose of loan"
          button1={"Next"}
          button1click={saveUserGeneralDetails}
          disabled1={!isFormValid()}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Purpose Of Loan"
              value={purposeOfloan}
              onChange={(e) => setPurposeOfLoan(e.target.value)}
              options={purposeOfLoanList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default PurposeOfLoan;
